export default {"src":"/_next/static/media/MTCH.92777958.svg","height":18,"width":18};